import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-add-user-group',
  templateUrl: './add-user-group.component.html',
  styleUrls: ['./add-user-group.component.scss'],
})
export class AddUserGroupComponent implements OnInit {

  breadcrumbList = [
    {
      label: 'User Group',
      url: '/baseapp/user-group'
    },
    {
      label: 'Add',
      url: '/baseapp/user-group/add'
    }
  ];
  userGroupObj;
  addUserGroupForm: UntypedFormGroup;
  // submitted: boolean = false;
  hide1200: boolean = false;
  userIp;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    public helperService: HelperService) { }

  ngOnInit() {
    this.addUserGroupForm = this.formBuilder.group({
      'groupName': ['', [Validators.required,this.checkGroupNameFormat()]],
      'group_description': [''],

    });
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });

    this.getUserIp();
  }
  
  private checkGroupNameFormat(): ValidatorFn {
    const invalidCharacters = /[^a-zA-Z0-9_]/; // allows  letters, numbers, and underscores
  
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value?.trim(); // Trim leading/trailing spaces
  
      if (val) {
        if (invalidCharacters.test(val)) {  
          return { invalidCharacters: true };  // Error if invalid characters are found
        }
      }
      return null; // Valid input
    };
  }
  

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  getUserIp() {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
      })
  }

  onSubmit() {
    // this.submitted = true;
    if (this.addUserGroupForm.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        created_by: res.userId,
        create_ip_address: this.userIp,
        updated_by: res.userId,
        update_ip_address: this.userIp,
        group_name: this.addUserGroupForm.value.groupName,
        group_description: this.addUserGroupForm.value.group_description,
      }
      //console.log(payload);
      this.backendService.PostAPICall('createGroup', payload, res.token).subscribe(
        (data) => {
          // this.submitted = false;
          this.helperService.closeLoader();
          this.helperService.presentToast(data.msg, 2000);
          this.router.navigate(['/baseapp/user-group']);
        },
        (error) => {
          //console.log(error);
          // this.submitted = false
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

}
